/**
 * 文字列の定数
 */
export const StringConsts = {
  /**
   * セッションストレージキー：エクソソーム
   */
  SESSION_STORAGE_KEY_EXOSOME: 'exosome',
  /**
   * セッションストレージキー：ビタミン
   */
  SESSION_STORAGE_KEY_VITAMIN: 'vitamin',
  /**
   * 文字列型の真
   */
  STR_TRUE: '1'
} as const satisfies Record<string, string>;
